// Where each role lands after signing in (LoginPage and pages/HubReturn).
// No "provider" case: the provider portal was removed (D-17). `provider` is
// still a valid site role in membershipService, so a user could hold it — they
// fall through to "/", which redirects to /login, the same place the kept
// /provider redirect would have sent them. Give that role a real home here if
// the portal is ever rebuilt.
//
// UI revamp (UI_REVAMP_ENABLED, staging only): roles whose personal home page
// is built land on /home instead. Step 2 = coordinators; step 3 = admins and
// owners; reception and referral follow in step 4. Flag off = exactly the old
// landing pages.
import { UI_REVAMP_ENABLED } from "../config/featureFlags";

const HOME_PAGE_ROLES = new Set(["coordinator", "admin", "owner"]);

export const roleHome = (r, revamp = UI_REVAMP_ENABLED) => {
  if (revamp && HOME_PAGE_ROLES.has(r)) return "/home";
  if (r === "admin" || r === "owner") return "/dashboard";
  if (r === "coordinator") return "/coordinator";
  if (r === "reception") return "/reception";
  if (r === "referral") return "/referral";
  return "/";
};
